import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { Subject } from 'rxjs';

import { SidebarDisplayStore } from '../../stores/signal-stores/sidebar-display-store/sidebar-display.store';
import { HelperService } from '../../utils/helper/helper.service';
import { SidebarWrapperComponent } from '../components/sidebar-wrapper/sidebar-wrapper.component';
import {
  SwitchCountrySidebarContentComponent
} from './components/switch-country-sidebar-content/switch-country-sidebar-content.component';

@Component({
  selector: 'app-country-switch-sidebar',
  imports: [
    TranslocoDirective,
    SidebarWrapperComponent,
    SwitchCountrySidebarContentComponent,
  ],
  providers: [
    HelperService
  ],
  templateUrl: './country-switch-sidebar.component.html',
  styleUrl: './country-switch-sidebar.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CountrySwitchSidebarComponent implements OnDestroy {
  public sidebarDisplayStore = inject(SidebarDisplayStore);

  protected primaryActionClicked$ = new Subject<void>();

  public ngOnDestroy(): void {
    this.primaryActionClicked$.complete();
  }

  public onActionButtonClicked(): void {
    this.primaryActionClicked$.next();
  }

  public closeSidebar(): void {
    this.sidebarDisplayStore.hideCountrySwitchSidebar();
  }
}
